const storeConfig = {
  to: 'https://rootstech2025.itemorder.com/shop/home/',
}

export default storeConfig
